var Const = /** @class */ (function () {
    function Const() {
    }
    //==================Order List========================
    Const.RUN_GET_ORDER_LIST = '/RUN_GET_ORDER_LIST';
    Const.GET_ORDER_LIST = '/GET_ORDER_LIST';
    Const.SET_ORDER_LIST = '/SET_ORDER_LIST';
    Const.GET_ORDER_LIST_SOCIAL = '/GET_ORDER_LIST_SOCIAL';
    Const.SET_ORDER_LIST_SOCIAL = '/SET_ORDER_LIST_SOCIAL';
    Const.GET_COMBINE_ORDER_LIST = '/GET_COMBINE_ORDER_LIST';
    Const.SET_COMBINE_ORDER_LIST = '/SET_COMBINE_ORDER_LIST';
    // =================crypto currency list============================
    Const.RUN_CRYPTO_LIST = '/RUN_CRYPTO_LIST';
    Const.GET_COMBINE_CRYPTO_LIST = '/GET_COMBINE_CRYPTO_LIST';
    Const.SET_COMBINE_CRYPTO_LIST = '/SET_COMBINE_CRYPTO_LIST';
    Const.GET_UNIQUE_CRYPTO_LIST = '/GET_UNIQUE_CRYPTO_LIST';
    Const.SET_UNIQUE_CRYPTO_LIST = '/SET_UNIQUE_CRYPTO_LIST';
    Const.GET_CRYPTO_LIST = '/GET_CRYPTO_LIST';
    Const.SET_CRYPTO_LIST = '/SET_CRYPTO_LIST';
    // =================Trading Account list============================
    Const.GET_MARGIN_INFO = '/GET_MARGIN_INFO';
    Const.GET_MARGIN = '/GET_MARGIN';
    Const.SET_MARGIN = '/SET_MARGIN';
    Const.GET_MARGIN_SOCIAL = '/GET_MARGIN_SOCIAL';
    Const.SET_MARGIN_SOCIAL = '/SET_MARGIN_SOCIAL';
    // =================Trading Account list============================
    Const.GET_FAVORITE_CURRENCY_LIST = '/GET_FAVORITE_CURRENCY_LIST';
    Const.ADD_FAVORITE_CURRENCY_LIST = '/ADD_FAVORITE_CURRENCY_LIST';
    // =================IP ADDRESS============================
    Const.RUN_GET_IP_ADDRESS_LIST = '/RUN_GET_IP_ADDRESS_LIST';
    Const.GET_IP_ADDRESS_LIST = '/GET_IP_ADDRESS_LIST';
    Const.SET_IP_ADDRESS_LIST = '/SET_IP_ADDRESS_LIST';
    Const.RUN_ADD_IP_ADDRES = '/RUN_ADD_IP_ADDRES';
    Const.RUN_UPDATE_IP_ADDRES = '/RUN_UPDATE_IP_ADDRES';
    // =================DEPOSIT HISTORY============================
    Const.RUN_GET_DEPOSIT_HISTORY = '/RUN_GET_DEPOSIT_HISTORY';
    Const.GET_DEPOSIT_HISTORY = '/GET_DEPOSIT_HISTORY';
    Const.SET_DEPOSIT_HISTORY = '/SET_DEPOSIT_HISTORY';
    // =================WITHDRAWAL HISTORY============================
    Const.RUN_GET_WITHDRAWAL_HISTORY = '/RUN_GET_WITHDRAWAL_HISTORY';
    Const.GET_WITHDRAWAL_HISTORY = '/GET_WITHDRAWAL_HISTORY';
    Const.SET_WITHDRAWAL_HISTORY = '/SET_WITHDRAWAL_HISTORY';
    Const.RUN_TRADING_ACCOUNT = '/RUN_TRADING_ACCOUNT_LIST';
    Const.GET_TRADING_ACCOUNT = '/GET_TRADING_ACCOUNT_LIST';
    Const.SET_TRADING_ACCOUNT = '/SET_TRADING_ACCOUNT_LIST';
    Const.GET_SOCIAL_ACCOUNT = '/GET_SOCIAL_ACCOUNT';
    Const.SET_SOCIAL_ACCOUNT = '/SET_SOCIAL_ACCOUNT';
    Const.GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
    Const.SET_NOTIFICATION_LIST = '/SET_NOTIFICATION_LISTS';
    //For social trading
    Const.RUN_CREATE_ACCOUNT = '/RUN_CREATE_ACCOUNT';
    Const.RUN_INTERNAL_TRANSFER_VERIFY = '/RUN_INTERNAL_TRANSFER_VERIFY';
    Const.RUN_GENERATE_API_KEY = '/RUN_GENERATE_API_KEY';
    //Api Key
    Const.GET_API_KEY = '/GET_API_KEY';
    Const.UPDATE_API_KEY = '/UPDATE_API_KEY';
    Const.DISABLE_API_KEY = '/DISABLE_API_KEY';
    Const.GET_ACCOUNT_SELECTED = '/GET_ACCOUNT_SELECTED';
    Const.SET_ACCOUNT_SELECTED = '/SET_ACCOUNT_SELECTED';
    /** Portfolio Report */
    Const.RUN_GET_PORTFOLIO_REPORT = '/RUN_GET_PORTFOLIO_REPORT';
    Const.GET_PORTFOLIO_REPORT = '/GET_PORTFOLIO_REPORT';
    Const.SET_PORTFOLIO_REPORT = '/SET_PORTFOLIO_REPORT';
    // watch-list
    Const.GET_WATCH_LIST_PAIRS = '/GET_WATCH_LIST_PAIRS';
    Const.SET_WATCH_LIST_PAIRS = '/SET_WATCH_LIST_PAIRS';
    /** Revenue Report */
    Const.RUN_GET_REVENUE_REPORT = '/RUN_GET_REVENUE_REPORT';
    Const.GET_REVENUE_REPORT = '/GET_REVENUE_REPORT';
    Const.SET_REVENUE_REPORT = '/SET_REVENUE_REPORT';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/trading/provider/lib/const.cls.ts
// module id = 1EQO
// module chunks = 1